export interface ISignatureProps {
  fullName: string;
  position: string;
  email: string;
  phone: string;
}

export const getSignatureHtml = ({
  fullName,
  email,
  phone,
  position,
}: ISignatureProps) => {
  return `
<table cellpadding="0" border="0" style="background: white; border-collapse: separate; border-spacing: 0;">
  <tbody>
    <tr>
      <td style="
            padding: 20px;
            padding-bottom: 0;
            background-image: url('https://signature.telcell.am/images/bg.png');
            background-color: #361766;
            background-repeat: repeat;
            vertical-align: top;
        ">
        <img src="https://signature.telcell.am/images/logo.png" style="display: block" height="23" />
      </td>
      <td style="
            padding: 20px;
            padding-top: 17px;
            padding-bottom: 0;
            vertical-align: top;
        ">
        <div style="line-height: 1">
          <span style="
                font-size: 21px;
                color: #361766;
                font-weight: bold;
                font-family: 'Montserrat', sans-serif;
                line-height: 1;
            ">${fullName}</span>
        </div>
        <div style="line-height: 1">
          <span style="
                display: block;
                margin-top: 3px;
                font-size: 10.5px;
                color: #361766;
                font-weight: 500;
                font-family: 'Montserrat', sans-serif;
            ">${position}</span>
          <br />
        </div>
      </td>
    </tr>
    <tr>
      <td style="
            padding: 20px;
            padding-top: 0;
            background-image: url('https://signature.telcell.am/images/bg.png');
            background-color: #361766;
            background-repeat: repeat;
            vertical-align: top;
        ">
        <div style="line-height: 1; margin-bottom: 4px; margin-top:20px;">
          <a target="_blank" href="https://telcell.am" class="display: inline-block;">
            <img src="https://signature.telcell.am/images/website.png" height="12" style="display: block; vertical-align: middle;" />
          </a>
        </div>
        <div style="line-height: 1;">
            <a href="tel:060-27-22-22" style="display: inline-block; margin-right: 15px; color:transparent; vertical-align: middle;">
              <img src="https://signature.telcell.am/images/phone.png" height="12" style="display:block; vertical-align: middle;" />
            </a>
          <div style="
                display: inline-block;
                vertical-align: middle;
                height: 12px;
            ">
            <a style="vertical-align: top; display: inline-block" href="https://www.facebook.com/telcell.am/" target="_blank">
              <img style="display: block; vertical-align: top" src="https://signature.telcell.am/images/fb.png" height="12" />
            </a>
            <a style="vertical-align: top; display: inline-block" href="https://www.instagram.com/telcellwallet/" target="_blank">
              <img style="display: block; vertical-align: top" src="https://signature.telcell.am/images/insta.png" height="12" />
            </a>
            <a style="vertical-align: top; display: inline-block" href="https://www.linkedin.com/company/telcellarmenia/" target="_blank">
              <img style="display: block; vertical-align: top;" src="https://signature-dev.telcell.am/images/linkedin.png" height="12" />
            </a>
          </div>
        </div>
      </td>
      <td style="padding: 20px; padding-top: 0; vertical-align: top">
        <div style="line-height: 1; margin-top: 19.5px; margin-bottom: 4px">
          <a href="mailto:${email}" style="
                display: block;
                font-size: 12px;
                color: #361766;
                font-family: 'Montserrat', sans-serif;
                text-decoration: underline;
            ">${email}</a>
        </div>
        <div style="line-height: 1; height:12px; margin-top:0; margin-bottom: 0;">
          <a href="tel:${phone}" style="
                font-size: 12px;
                color: #361766;
                font-family: 'Montserrat', sans-serif;
                text-decoration: underline;
            ">${phone}</a>
        </div>
      </td>
    </tr>
  </tbody>
</table>
    `;
};
